import Group from "../../entities/group";

/**
 * Group actions
 *
 * Call order:
 *
 * GROUP_SAVE_QUEUE:	adds the item to the save queue
 * --> GROUP_SAVE:	modifies the state
 * --> GROUP_SAVE_SUCCESS: if all went well
 * --> GROUP_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail GROUP_SAVE_QUEUE is during the call to GROUP_SAVE,
 * as adding an item to the queue should never fail.
 */

export const GROUP_FETCH_ONE_QUEUE: any = 'GROUP_FETCH_ONE_QUEUE';
export const GROUP_FETCH_SUCCESS: any = 'GROUP_FETCH_SUCCESS';
export const GROUP_FETCH_FAILURE: any = 'GROUP_FETCH_FAILURE';
export const GROUP_FETCH_ONE_SUCCESS: any = 'GROUP_FETCH_ONE_SUCCESS';
export const GROUP_FETCH_ONE_FAILURE: any = 'GROUP_FETCH_ONE_FAILURE';

export const GROUP_SAVE: any = 'GROUP_SAVE';
export const GROUP_SAVE_QUEUE: any = 'GROUP_SAVE_QUEUE';
export const GROUP_SAVE_SUCCESS: any = 'GROUP_SAVE_SUCCESS';
export const GROUP_SAVE_FAILURE: any = 'GROUP_SAVE_FAILURE';

export const GROUP_SAVE_MANY: any = 'GROUP_SAVE_MANY';
export const GROUP_SAVE_MANY_QUEUE: any = 'GROUP_SAVE_MANY_QUEUE';
export const GROUP_SAVE_MANY_SUCCESS: any = 'GROUP_SAVE_MANY_SUCCESS';
export const GROUP_SAVE_MANY_FAILURE: any = 'GROUP_SAVE_MANY_FAILURE';

export const GROUP_REMOVE: any = 'GROUP_REMOVE';
export const GROUP_REMOVE_QUEUE: any = 'GROUP_REMOVE_QUEUE';
export const GROUP_REMOVE_SUCCESS: any = 'GROUP_REMOVE_SUCCESS';
export const GROUP_REMOVE_FAILURE: any = 'GROUP_REMOVE_FAILURE';

export const GROUP_RESTORE: any = 'GROUP_RESTORE';
export const GROUP_RESTORE_QUEUE: any = 'GROUP_RESTORE_QUEUE';
export const GROUP_RESTORE_SUCCESS: any = 'GROUP_RESTORE_SUCCESS';
export const GROUP_RESTORE_FAILURE: any = 'GROUP_RESTORE_FAILURE';

export const GROUP_RESTORE_MANY: any = 'GROUP_RESTORE_MANY';
export const GROUP_REMOVE_MANY: any = 'GROUP_REMOVE_MANY';

/* Fetch actions */
export const fetchGroupSuccess = (groups: Group[], partial: boolean, lastFetch: number) => ({type: GROUP_FETCH_SUCCESS, groups, partial, lastFetch});
export const fetchGroupFailure = (err: any) => {
		console.error('GroupAction: fetchGroupFailure', err);
		return {type: GROUP_FETCH_FAILURE, err};
};
export const fetchOneGroupQueue = (groupId: string) => ({type: GROUP_FETCH_ONE_QUEUE, groupId});
export const fetchOneGroupSuccess = (group: Group) => ({type: GROUP_FETCH_ONE_SUCCESS, group});
export const fetchOneGroupFailure = (id: string, err: any) => {
		console.error('GroupAction: fetchOneGroupFailure', err);
		return {type: GROUP_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveGroup = (group: Group) => {
    // console.debug('⮂ GROUP_SAVE action', group?.id);
    return {type: GROUP_SAVE, group};
}
export const saveGroupQueue = (group: Group, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ GROUP_SAVE_QUEUE action', group?.id);
    return {type: GROUP_SAVE_QUEUE, group, onQueued};
}
export const saveGroupSuccess = (group: Group) => {
    // console.debug('⮂ GROUP_SAVE_SUCCESS action', group?.id);
    return {type: GROUP_SAVE_SUCCESS, group};
}
export const saveGroupFailure = (group: Group, status: number, message: string) => {
    console.warn(`⮂ GROUP_SAVE_FAILURE error saving group: HTTP ${status}: ${message}`, group?.id);
    return {type: GROUP_SAVE_FAILURE, group, status, message};
};

/* SaveMany actions */
export const saveManyGroups = (groups: Group[]) => {
    // console.debug('⮂ GROUP_SAVE_MANY action', groups?.map(group => group?.id).join(','));
    return {type: GROUP_SAVE_MANY, groups};
}
export const saveManyGroupsQueue = (groups: Group[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ GROUP_SAVE_MANY_QUEUE action', groups?.map(group => group.id).join(','));
    return {type: GROUP_SAVE_MANY_QUEUE, groups, onQueued};
}

export const saveManyGroupsSuccess = (groups: Group[]) => {
    // console.debug('⮂ GROUP_SAVE_MANY_SUCCESS action', groups?.map(group => group.id).join(','));
    return {type: GROUP_SAVE_MANY_SUCCESS, groups};
}
export const saveManyGroupsFailure = (groups: Group[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_GROUPS_FAILURE Error saving groups: HTTP ${status}: ${message}`, groups?.map(group => group.id).join(','));
		return {type: GROUP_SAVE_MANY_FAILURE, groups, status, message};
};

/* Remove actions */
export const removeGroup = (group: Group) => ({ type: GROUP_REMOVE, group });
export const removeGroupQueue = (group: Group) => ({ type: GROUP_REMOVE_QUEUE, group });
export const removeGroupSuccess = (group: Group) => ({ type: GROUP_REMOVE_SUCCESS, group });
export const removeGroupFailure = (group: Group, status: number, message: string) => {
	console.error(`Redux: removeGroupFailure Error removing group: HTTP ${status}: ${message}`);
	return ({ type: GROUP_REMOVE_FAILURE, group, status, message });
};

/* Restore actions */
export const restoreGroup = (group: Group) => ({ type: GROUP_RESTORE, group });
export const restoreGroupQueue = (group: Group) => ({ type: GROUP_RESTORE_QUEUE, group });
export const restoreGroupSuccess = (group: Group) => ({ type: GROUP_RESTORE_SUCCESS, group });
export const restoreGroupFailure = (group: Group, status: number, message: string) => {
	console.error(`Redux: restoreGroupFailure Error restoring group: HTTP ${status}: ${message}`);
	return ({ type: GROUP_RESTORE_FAILURE, group, status, message });
};

/* RestoreMany actions */
export const restoreManyGroups = (groups: Group[]) => ({ type: GROUP_RESTORE_MANY, groups });

/* RemoveMany actions */
export const removeManyGroups = (groups: Group[]) => ({ type: GROUP_REMOVE_MANY, groups });